<template>
  <div class="main-container">
    <!-- 按钮区域 -->
    <div class="button-section">
      <el-form :inline="true">
        <el-form-item>
          <el-input
              v-model="dyIDSearch"
              placeholder="抖音id"
              clearable
              @clear="resetSearch"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="filterBaohu">搜索</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="insertBaohu">新增</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="danger" @click="delBaohu" v-if="hasAuth('sys:baohu:del')">删除</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="table-section">
      <el-table
          :data="filteredTableData"
          border
          stripe
          height="95%"
          v-model:selection="selectedRows"
          @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="序号" width="80">
          <template #default="{ $index }">
            {{ ($index + 1) + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column prop="dyID" label="ID" width="220"></el-table-column>
        <el-table-column prop="imgURL" label="主图" width="60">
          <template #default="{ row }">
            <div class="thumbnail-wrapper" @mouseenter="showLargeImagePopup(row.imageURL)" @mouseleave="hideLargeImagePopup">
              <img :src="row.imageURL" class="thumbnail" alt="主图" />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" width="800"></el-table-column>
        <el-table-column prop="yongjin" label="佣金" sortable></el-table-column>
        <el-table-column prop="changeTime" label="添加时间" sortable></el-table-column>
        <el-table-column prop="changeName" label="操作人" sortable></el-table-column>
      </el-table>

      <el-pagination
          class="pagination"
          background
          layout="total, prev, pager, next, sizes"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @current-change="fetchTableData"
          @size-change="handleSizeChange"
      ></el-pagination>
    </div>

    <!-- 放大图 -->
    <div v-if="showLargeImage" class="large-image-container">
      <img :src="largeImageSrc" class="large-image" alt="放大图" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dyIDSearch: '',
      originalTableData: [],
      filteredTableData: [],
      showLargeImage: false,
      largeImageSrc: '',
      selectedRows: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  created() {
    this.fetchTableData();
  },
  methods: {
    fetchTableData() {
      const searchTerm = this.dyIDSearch?.trim() ?? '';
      const cleanedSearchTerm = searchTerm.replace(/^dy[-_]/, '').toLowerCase();

      this.$axios
          .get('/sys/weijinci/getbaohuList', {
            params: {
              page: this.currentPage,
              size: this.pageSize,
              dyID: cleanedSearchTerm
            }
          })
          .then(res => {
            const pageData = res.data?.data;
            if (pageData) {
              const records = pageData.records || [];
              this.originalTableData = records.map(item => {
                if (!item.imageURL || item.imageURL === 'null') {
                  item.imageURL = require('@/assets/xiaodu.jpg');
                }
                return item;
              });
              this.filteredTableData = [...this.originalTableData];
              this.total = pageData.total;
            }
          })
          .catch(() => {
            this.$message.error('获取数据失败！');
          });
    },
    filterBaohu() {
      this.currentPage = 1;
      this.fetchTableData();
    },
    resetSearch() {
      this.dyIDSearch = '';
      this.currentPage = 1;
      this.fetchTableData();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchTableData();
    },
    delBaohu() {
      if (!this.selectedRows.length) {
        this.$message.warning('请至少选择一条要删除的记录！');
        return;
      }

      this.$confirm(`确定要删除选中的 ${this.selectedRows.length} 条记录吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            const dyIDs = this.selectedRows.map(item => item.dyID);
            return this.$axios.post('/sys/weijinci/delBaohu', { dyIDs });
          })
          .then(response => {
            if (response.data?.code === 200) {
              this.$message.success('删除成功！');
              this.fetchTableData();
              this.selectedRows = [];
            } else {
              this.$message.error(response.data?.msg || '删除失败！');
            }
          })
          .catch(() => {
            this.$message.info('已取消删除操作');
          });
    },
    insertBaohu() {
      if (!this.dyIDSearch.trim()) {
        this.$message.warning('抖音ID不能为空！');
        return;
      }

      let dyID = this.dyIDSearch.trim();
      if (dyID.startsWith('dy-')) dyID = dyID.substring(3);

      if (!/^\d{19}$/.test(dyID)) {
        this.$message.warning('抖音ID必须是19位纯数字或dy-开头的19位数字！');
        return;
      }

      // 封装老式复制方法
      const copyToClipboard = (text) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';  // 避免滚动到底部
        document.body.appendChild(textarea);
        textarea.select();

        try {
          const successful = document.execCommand('copy');
          if(successful) {
            this.$message.success(`抖音ID ${text} 已复制到剪切板`);
          } else {
            throw new Error('复制命令失败');
          }
        } catch (err) {
          this.$message.error('复制失败，请手动复制');
        } finally {
          document.body.removeChild(textarea);
        }
      };

      this.$axios
          .post('/sys/weijinci/insertBaohu', { dyID })
          .then(response => {
            const res = response.data;
            if (res.code === 200) {
              this.$message.success('保护产品添加成功！');
              copyToClipboard(dyID);  // 添加成功后复制ID
              this.dyIDSearch = '';
              this.currentPage = 1;
              this.fetchTableData();
            } else {
              copyToClipboard(dyID);  // ID已存在时也复制ID
              this.$message.warning('该抖音ID已存在，正在为你搜索...');
              this.filterBaohu();
            }
          })
          .catch(() => {
            copyToClipboard(dyID);  // 异常情况下也复制ID
            this.filterBaohu();
          });
    },



    showLargeImagePopup(src) {
      this.largeImageSrc = src;
      this.showLargeImage = true;
    },
    hideLargeImagePopup() {
      this.showLargeImage = false;
    }
  },
  hasAuth(code) {
    // 模拟权限函数，需要根据实际权限逻辑替换
    return true;
  }
};
</script>

<style scoped>
.main-container {
  display: flex;
  flex-direction: column;
  height: 85vh;
  background-color: #f5f7fa;
  padding: 5px;
  box-sizing: border-box;
}
.button-section {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  padding: 10px;
}
.table-section {
  flex-grow: 1;
  padding: 10px;
  overflow: hidden;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fff;
}
.thumbnail-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}
.thumbnail-wrapper:hover .thumbnail {
  transform: scale(1.2);
}
.large-image-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  background: rgba(0, 0, 0, 0);
  padding: 1px;
  border-radius: 10px;
}
.large-image {
  max-width: 80vw;
  max-height: 80vh;
  border: 2px solid #fff;
  border-radius: 10px;
}
.pagination {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
</style>
